<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
			@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->


		<div style="margin-top: 0px;">

			<!-- 内容 -->
			<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
				<div style="width:1200px;margin:auto;padding:20px;">
					<rosidebar :selected_page='selected_page'></rosidebar>
					<el-dialog title="微信支付" :visible.sync="wxpay_dialogVisible" width="40%" :before-close="handleClose">
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" :title="order_pay_title" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">微信收银</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥
											{{select_shopcart_total}}元</span>
									</div>
								</template>
							</el-result>
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt2 }}</p>
								<img style="height: 100px;" :src='wx_pay_img' />								
							</div>
						</div>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%;margin-top: 5%;"
								@click="handleClose">退出</el-button>
						</div>
					</el-dialog>
					
					<el-dialog title="支付宝" :visible.sync="alipay_dialogVisible" width="40%" :before-close="handleClose">
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" title="支付宝" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">支付宝</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥
											{{select_shopcart_total}}元</span>
									</div>
								</template>
							</el-result>
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt3 }}</p>
								<iframe style="width: 100%;height:110px;margin-left:30% vertical-align: middle;" :src='ali_pay_img'></iframe>								
							</div>
						</div>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%;margin-top: 5%;"
								@click="handleClose">退出</el-button>
						</div>
					</el-dialog>

					<el-dialog title="转账汇款" :visible.sync="dialogVisible_duigong" width="40%"
						:before-close="handleClose">

						<el-upload class="upload-demo" ref="upload" :action="uploadUrl" list-type="picture-card"
							:before-upload="beforeUpload" :on-remove="handleRemove" :file-list="fileList"
							:auto-upload="false" accept=".png,.jpg,.jpeg" multiple :data="{ order_id: order_id }">
							<el-button slot="trigger" size="small" type="primary">选取图片</el-button>
							<div slot="tip" class="el-upload__tip">请您转账时在附加或备注信息中填写<span
									style='color:red'>手机号码</span>,上传的转账凭证图片要完整、清晰，以便我们及时处理您的订单。图片大小在500K以内。
							</div>
						</el-upload>
						<el-button style="margin-left: 10px;" size="small" type="success"
							@click="submitUpload">确认上传</el-button>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%;margin-top: 5%;"
								@click="handleClose">退出</el-button>
						</div>

					</el-dialog>



					<div style="float: right;width:calc(100% - 269px);;background: white;">
						<div style="width: 90%;margin:20px auto;">
							<el-steps :active="active" finish-status="success" simple style="margin-top: 20px">
								<el-step title="购物车" icon="el-icon-edit"></el-step>
								<el-step title="提交订单" icon="el-icon-edit"></el-step>
							</el-steps>
						</div>
						<!-- 结算页面 -->
						<div v-if="this.active == 0" style="width: 90%;margin:20px auto;overflow: hidden;">
							<el-table ref="multipleTable" key="shopcart" :data="shopcart" tooltip-effect="dark"
								style="width: 100%;" @selection-change="handleSelectionChange">
								<el-table-column type="selection" width="55">
								</el-table-column>
								<el-table-column label="" width="80">
									<template slot-scope="scope">
										<img :src="scope.row.image" style="width:80px;loat:left;" />

									</template>
								</el-table-column>
								<el-table-column prop="name" label="商品名称" width="220">

								</el-table-column>

								<el-table-column prop="price" label="单价" width="100">
								</el-table-column>
								<el-table-column label="数量" width="180">
									<template slot-scope="scope">
										<el-input-number v-model="scope.row.qty" :min='1'
											@change="handleQuantityChange(scope.row)"></el-input-number>
									</template>
								</el-table-column>
								<el-table-column prop="total" label="小计" width="100">
								</el-table-column>
								<el-table-column label="操作" width="80">
									<template slot-scope="scope">
										<i class="el-icon-delete" @click="delete_shopcart(scope.row)"></i>
									</template>
								</el-table-column>
							</el-table>
							<div
								style="width: 100%;height:40px;line-height: 40px;margin-top: 20px;text-align: left;font-size: 12px;color:gray;">
								<span style="padding:0 10px;border-right: 1px solid #cdcdcd;">
									<a href="#/">继续购物</a>
								</span>
								<span style="padding:0 10px;">已选择{{select_shopcart_qty}}件</span>
								<span style="float: right;">
									<el-button @click="handleCheckout"
										style="background-color: orangered;width: 200px;color:white;">
										去结算</el-button>
								</span>
								<span style="float: right;margin-right:20px;color:orangered;">
									合计：<span style="font-size: 24px;">{{select_shopcart_total}}</span>元
								</span>
							</div>
						</div>
						<!-- 提交订单页面 -->
						<div v-if="this.active == 1" style="width: 90%;margin:20px auto;overflow: hidden;">
							<el-form :model="form_setp_1" ref="form_setp_1" :rules="form_setp_1_rules"
								label-width="100px" class="demo-ruleForm" style="padding:10px;">
								<!-- 	<el-form-item prop='name' label="项目名称">
									<el-input v-model="form_setp_1.name"></el-input>
								</el-form-item>
								<el-form-item prop='en_name' label="英文名称">
									<el-input v-model="form_setp_1.en_name" placeholder="国内检索无需填写此项"> </el-input>
								</el-form-item> -->


								<div style="width:100%;border:2px dotted #cdcdcd;padding:20px;overflow: hidden;">
									<el-row>
										<div style="margin-top: 10px;float:left">
											送货地址：
										</div>
										<el-button @click="turn_to_new_address" type="danger"
											style="margin-bottom: 20px;float:right">新增收货地址
										</el-button>
									</el-row>
									<el-radio-group v-model="address_selected" @change="select_address">
										<el-radio :label="item.id" border v-for="(item,index) in address_datas">
											<span style="width: 100%;" :data-id="item.id">{{item.receiver_name}}</span>
											<!-- <div style="width: 100%;" :data-id="item.id" > -->
											{{item.contact_mobile}},{{item.province}}{{item.city}}{{item.area}}{{item.address}}
											<!-- </div> -->
											<span v-if="address_selected == item.id" style="float: right;color:#409EFF"
												@click="change_address = true">修改</span>

										</el-radio>
									</el-radio-group>

								</div>
								<el-dialog title="修改地址" :visible.sync="change_address" style="text-align: left;">

									<div style="overflow: hidden;">
										<el-form-item label="地址信息" prop="address" style="float: left;width: 100%;">
											<el-cascader style="width: 100%;" size="large" :options="AreaOptions"
												v-model="selectedArea" @change="handleChangeArea">
											</el-cascader>
										</el-form-item>


									</div>
									<div style="overflow: hidden;">
										<el-form-item label="详细地址" prop="address" style="float: right;width: 100%;">
											<el-input v-model="form_setp_1.address"></el-input>
										</el-form-item>
									</div>
									<div style="overflow: hidden;">

										<el-form-item label="邮政编码" prop="postcode" style="float: right;;width: 100%;">
											<el-input v-model="form_setp_1.postcode"></el-input>
										</el-form-item>

									</div>

									<div style="overflow: hidden;">
										<el-form-item label="收件人" prop="contact" style="float: left;width: 100%;">
											<el-input v-model="form_setp_1.contact"></el-input>
										</el-form-item>


									</div>
									<div style="overflow: hidden;">

										<el-form-item label="手机" prop="contact_mobile" style="float: left;width: 100%;">
											<el-input v-model="form_setp_1.contact_mobile"></el-input>
										</el-form-item>

									</div>
									<div slot="footer" class="dialog-footer">
										<el-button @click="change_address = false">取 消</el-button>
										<el-button type="primary" @click="update_address ">确 定</el-button>
									</div>
								</el-dialog>




							</el-form>


							<el-table key="order_line" :data="order_line" tooltip-effect="dark" style="width: 100%;">

								<el-table-column label="" width="100">
									<template slot-scope="scope">
										<img :src="scope.row.image" style="width:80px;loat:left;" />

									</template>
								</el-table-column>
								<el-table-column prop="name" label="商品名称" width="280">

								</el-table-column>

								<el-table-column prop="price" label="单价" width="100">
								</el-table-column>
								<el-table-column prop="qty" label="数量" width="180">

								</el-table-column>
								<el-table-column prop="total" label="小计" width="130">
								</el-table-column>

							</el-table>


							<div
								style="width: 100%;height:40px;line-height: 40px;margin-top: 20px;text-align: left;font-size: 12px;color:gray;">

								<span style="float: right;">
									<div style="width: 500px;overflow: hidden;">
										<div style="margin-right:20px;float: right;color:#000000;">
											总计：<span style="color:#333;font-size: 18px;">¥</span>
											<span
												style="font-size: 24px;color:orangered">{{select_shopcart_total}}</span>
										</div>

									</div>


								</span>


							</div>
							<div style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
								<div>请选择支付方式并支付</div>
							</div>
							<div>
								<img src="../assets/wx_pay.jpg" style="cursor: pointer;width: 220px; height: 120px;"
									@click="finish_order('wxpay')" alt="微信支付">
								<!-- <img src="../assets/ali_pay.jpg" style="cursor: pointer;width: 220px; height: 120px;"
									@click="finish_order('alipay')" alt="支付宝支付"> -->
								<img src="../assets/duigong.jpg" style="cursor: pointer;width: 120px; height: 120px;"
									@click="finish_order('duigong')" alt="对公支付">
							</div>


							<!-- <el-button @click="finish_order"
								style="float: right; background-color: orangered;width: 200px;color:white;">
								提交订单
							</el-button> -->
							<span style="padding:0 10px;float: right;">
								<span @click="back" style="color:#07ccec">
									<i></i>返回购物车
								</span>
							</span>
						</div>




					</div>

				</div>
			</div>
			<!-- 页脚 -->
			<rofooter></rofooter>
		</div>



	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	import testprops from "./components/test_props.vue";
	import {
		baseURL
	} from "../utils/baseURL"
	import {
		fetchPost
	} from "@/utils/request"
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	export default {
		name: "App",
		data() {
			return {
				wxpay_dialogVisible: false,
				alipay_dialogVisible: false,
				dialogVisible_duigong: false,
				uploadUrl: baseURL + '/ro/web_eshop/order/file/update/v1', // 文件上传的接口地址
				order_id: 0,
				order_name: '',
				can_get_pay_state: true,				
				shopcart_qty: 0,
				shopcart_total: 0,
				select_shopcart_total: 0,
				select_shopcart_qty: 0,
				address_selected: '',
				address_datas: '',
				payName: '微信支付',
				selected_page: '2-1',
				address_checked: true,
				change_address: false,
				form_setp_1: {
					'name': '',
					'en_name': '',
					'unit_name': '',
					'address': '',
					'postcode': '',
					'contact': '',
					'contact_mobile': '',
					'contact_phone': '',
					'email': ''
				},
				AreaOptions: regionData,
				selectedArea: [],
				form_setp_1_rules: {

					unit_name: [{
						required: true,
						message: '单位名称不能为空',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '地址不能为空',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contact_mobile: [{
						required: true,
						message: '手机不能为空',
						trigger: 'blur'
					}],
					postcode: [{
						required: true,
						message: '邮编不能为空',
						trigger: 'blur'
					}],
					contact_phone: [{
						required: false
					}],
				},
				goods_num: '1',
				active: 0,
				order_line: [],
				shopcart: [],

				orderList: [],
				
				order_pay_title: '订单创建成功',
				prompt1: '请在',
				prompt2: '秒内微信扫描二维码支付',
				prompt3: '秒内支付宝扫描二维码支付',
				dialogVisible: false,
				loading: true,
				paying: false,
				ali_pay_img: '',
				wx_pay_img: 'https://p2.itc.cn/images01/20211001/f2b77a3dd20f4be88cd84a9d659fa1cb.jpeg',
				fileList: [],
				countdown: 60, // 倒计时初始值
				countdownTimer: null, // 用于保存倒计时定时器的引用
				get_pay_state_timer: null,
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.get_shop_cart()
			this.compute_shopcart()
			this.get_address_data()
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,
		},
		methods: {

			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 < 500;

				console.log(file.size)
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 500kb!');
					// return
				}
				return isLt2M

			},
			submitUpload() {
				// debugger
				// this.
				this.$loading('处理中')
				var self = this
				var uploadFiles = this.$refs.upload.uploadFiles
				var file_data = []
				var order_id = this.order_id
				for (var i = 0; i < uploadFiles.length; i++) {
					// console.log(uploadFiles[i].name)
					var name = uploadFiles[i].name
					var file = uploadFiles[i].raw
					// debugger

					const reader = new FileReader();
					reader.onload = (e) => {
						var data = {
							// 'order_id': order_id,
							'data': e.target.result,
							'name': name,
						}
						file_data.push(data)
						self.file_data = file_data

					};
					reader.readAsDataURL(file);

					// debugger
				}

				setTimeout(function() {
					var data = {
						'order_id': self.order_id,
						'file_data': JSON.stringify(self.file_data)
					}
					fetchPost('/ro/web_eshop/order/file/update/v1', data).then(response => {
						self.$message.success('上传成功')						
						setTimeout(function() {
							self.$loading().close()
							self.$router.push('/user/order')

						}, 1000)

					})
				}, 1500)


			},		
			stop_pay_state_timer() {
			  if (this.get_pay_state_timer) {
				console.log("删除get_pay_state_timer定时器！");
				clearInterval(this.get_pay_state_timer);
				this.get_pay_state_timer = null;  // 手动将 self.get_pay_state_timer 设置为 null
			  }
			},
			stop_countdownTimer() {
			  // 清除倒计时定时器
			  if (this.countdownTimer) {
				console.log("删除countdownTimer倒计时定时器！");
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			  }
			},
			handleClose() {
				this.stop_pay_state_timer()
				this.stop_countdownTimer()				
				this.wxpay_dialogVisible = false
				this.alipay_dialogVisible = false
				this.dialogVisible_duigong = false
				this.countdown = 60
				if(this.payment_status == "success")
				{
					this.turn_to_invoice();
					this.payment_status = null;
					this.prompt1 = '请在';
					this.prompt2 = '秒内微信扫描二维码支付';
					this.prompt3 = '秒内支付宝扫描二维码支付';
				}
			},			
			
			get_pay_state() {
				var self = this
				var data = {
					'id': this.order_id
				}				
				fetchPost('/ro/eshop/order/get_payment_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.result == 'success') {
						self.order_pay_title = '订单支付完成,5s后将自动跳转'
						this.stop_pay_state_timer()						
						//等待10秒弹出开发票页面
						setTimeout(function() {
							self.turn_to_invoice()
						}, 10000)
						this.payment_status = "success";
						this.countdown = 5;
						this.prompt1 = '本页面将在';
						this.prompt2 = '秒后自动退出！';
						this.prompt3 = '秒后自动退出！';
						this.wx_pay_img = require('../assets/payment_success.png');
						this.ali_pay_img = '/alipay_success_image.html'						
					}
				})
			},
			startCountdown() {
				this.countdownTimer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
						console.log(this.countdown);
					} else {						
						this.handleClose(); // 倒计时结束时调用 handleClose						
					}
				}, 1000);
			},			
			turn_to_invoice() {
				window.location.href = '#/user/invoice?id=' + this.order_id + '&total_fees=' + this.select_shopcart_total
				// this.$router.push('/user/invoice?id=' + this.order_id + '&total_fees=' + this.select_shopcart_total)
			},
			ali_pay() {
				// debugger
				this.ali_pay_img = baseURL + '/ro/connector/alipay/ali_pay/v1?type=eshop&order_id=' + this.order_id + '&date=' + Date.now();
				console.log('finish_order 549行，this.ali_pay_img = ' + this.ali_pay_img)
				setTimeout(() => {  
				        // 这里是等待3秒后执行的代码  
				        console.log('已经等待了3秒');  
				        // 你可以在这里调用其他方法或执行其他操作  
						this.loading = false
						console.log('finish_order 555行，this.loading = ' + this.loading)
						console.log('finish_order 556行，this.ali_pay_img = ' + this.ali_pay_img)
				}, 3000); // 3000毫秒 = 3秒  
				this.paying = true
				if (!this.get_pay_state_timer) {
					console.log('新建 get_pay_state_timer')					
					this.get_pay_state_timer = setInterval(() => {
						console.log('循环查询订单支付情况')
						this.get_pay_state()
					}, 1000)
				}
			},
			wx_pay() {
				// debugger
				var data = {
					'order_id': this.order_id,
					'type': 'eshop'
				}
				var self = this				
				fetchPost('/ro/connector/wx/wx_pay_native/v1', data).then(response => {
					console.log(response.data)
					this.wx_pay_img = response.data //获得的微信支付二维码
					this.loading = false
					this.paying = true
					
					if (this.get_pay_state_timer == null) {
						console.log('新建 get_pay_state_timer')						
						this.get_pay_state_timer = setInterval(() => {
							console.log('循环查询订单支付情况')
							this.get_pay_state()
						}, 1000)
						// debugger						
					}
				})				
			},

			finish_order(type) {
				// debugger
				if (this.address_selected == '') {
					this.$message.warning('请添加收货地址')
					return
				}
				var data = {
					'order_line': JSON.stringify(this.order_line),
					'user_id': localStorage.getItem('eshop_user_id'),
					'address_id': this.address_selected,
				}
				var self = this
				// debugger
				// debugger
				var shopcart = this.shopcart
				// debugger
				for (var index = 0; index < this.order_line.length; index++) {
					// debugger
					var will_delete_product = this.shopcart.filter(item => item.id == this.order_line[index].id);
					var delete_index = this.shopcart.indexOf(will_delete_product[0]);
					console.log(delete_index)
					shopcart.splice(delete_index, 1);
				}
				this.shopcart = shopcart
				localStorage.setItem('shopcart', JSON.stringify(shopcart))
				this.get_shop_cart()
				this.compute_shopcart()
				// debugger
				fetchPost('/ro/web_eshop/order/create/v1', data).then(response => {
					var order_id = response.data.order_id
					var order_name = response.data.order_name
					self.order_id = order_id
					self.order_name = order_name
					self.dialogVisible = true					
					if (type == 'wxpay') {
						self.wxpay_dialogVisible = true
						self.wx_pay()
					}
					if (type == 'duigong') {
						self.dialogVisible_duigong = true
						self.duigong_pay()
					}
					if (type == 'alipay') {
						self.alipay_dialogVisible = true
						self.ali_pay()
					}
					self.loading = true
					this.startCountdown();
				})				
			},
			update_address() {
				var id = this.address_selected
				var data = {
					'id': id,
					'address': this.form_setp_1.address,
					'postcode': this.form_setp_1.postcode,
					'receiver_name': this.form_setp_1.contact,
					'mobile': this.form_setp_1.contact_mobile,
					'province': this.province,
					'city': this.city,
					'area': this.area,
					'default': this.checked,

				}
				console.log('update-------')
				console.log(data)
				// debugger
				var self = this
				// self.handleClose()
				this.$refs.form_setp_1.validate(valid => {
					if (valid) {
						fetchPost('/ro/web_eshop/user/address/edit/v1', data).then(response => {
							// self.handleClose()
							self.$message.success('更新成功')
							self.change_address = false
							self.get_address_data()
							// self.$router.back()

						})
					} else {
						self.$message.error('请完善必填字段')
					}
				})
			},
			handleCheckout() {
				if (this.select_shopcart_qty === 0) {
					this.$alert('请至少选中一件商品！', '提示', {
						confirmButtonText: '确定',
						type: 'warning',
					});
				} else {
					this.next(); // 调用原来的结算方法
				}
			},
			next() {
				if (this.active++ > 2) this.active = 0;
			},
			back() {
				this.active = 0
				// this.$refs.multipleTable.clearSelection()
				this.order_line = []
				this.select_shopcart_qty = 0
				this.select_shopcart_total = 0
			},
			delete_shopcart(shopcart_detail) {
				var shop_cart = this.shopcart;
				var will_delete_product = this.shopcart.filter((item) => item.id == shopcart_detail.id);
				var delete_index = this.shopcart.indexOf(will_delete_product[0]);
				// debugger
				shop_cart.splice(delete_index, 1);
				// debugger

				this.shopcart = shop_cart

				localStorage.setItem('shopcart', JSON.stringify(shop_cart));
				this.get_shop_cart()
				this.compute_shopcart()
			},

			handleQuantityChange(product_data) {
				// 在输入框的值发生变化时更新列表数据源中对应项的值
				// 进行其他操作，如保存数据等
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var qty = product_data.qty
				var same_shop_cart = shopcart.filter((item) => item.id == product_data.id)
				// debugger
				var index = shopcart.indexOf(same_shop_cart[0]);
				shopcart[index].qty = qty;
				var total = qty * product_data.price
				shopcart[index].total = parseFloat(total).toFixed(2)

				localStorage.setItem('shopcart', JSON.stringify(shopcart));
				this.shopcart = shopcart;
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total += parseFloat(shopcart[i].total)
				}
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
				var self = this
				var order_line = self.order_line

				this.$refs.multipleTable.clearSelection()


				this.$nextTick(_ => {
					self.shopcart.forEach(shopcart => {
						order_line.forEach(row => {
							if (shopcart.id == row.id) {
								self.$refs.multipleTable.toggleRowSelection(shopcart)
							}
						})
					});
				})
			},

			set_default_address() {
				var self = this
				// debugger

				var select_address_data = self.address_datas.filter(item => item.default == true)[0]
				console.log(select_address_data)
				// self.form_setp_1.unit_name = select_address_data.unit_name
				self.form_setp_1.postcode = select_address_data.postcode
				self.form_setp_1.address = select_address_data.address
				self.form_setp_1.email = select_address_data.email
				self.form_setp_1.contact = select_address_data.receiver_name
				self.form_setp_1.contact_mobile = select_address_data.mobile
				self.address_selected = select_address_data.id
				// debugger
				self.province = select_address_data.province
				self.city = select_address_data.city
				self.area = select_address_data.area

				var province = TextToCode[select_address_data.province].code
				var city = TextToCode[select_address_data.province][select_address_data.city].code
				var area = TextToCode[select_address_data.province][select_address_data.city][select_address_data.area]
					.code
				self.selectedArea = [province, city, area]

			},
			handleChangeArea(value) {
				this.province = CodeToText[value[0]]
				this.city = CodeToText[value[1]]
				this.area = CodeToText[value[2]]
				console.log(this.province)
				console.log(this.city)
				console.log(this.area)
			},
			select_address(e) {
				// debugger
				var id = e
				var select_address_data = this.address_datas.filter(item => item.id == id)[0]
				// debugger
				// this.form_setp_1.unit_name = select_address_data.unit_name
				// this.form_setp_1.postcode = select_address_data.postcode
				// debugger
				this.form_setp_1.address = select_address_data.address
				this.form_setp_1.email = select_address_data.email
				this.form_setp_1.contact = select_address_data.receiver_name
				// this.form_setp_1.contact_phone = select_address_data.contact_phone
				this.form_setp_1.contact_mobile = select_address_data.mobile

				var province = TextToCode[select_address_data.province].code
				var city = TextToCode[select_address_data.province][select_address_data.city].code
				var area = TextToCode[select_address_data.province][select_address_data.city][select_address_data.area]
					.code
				this.province = select_address_data.province
				this.city = select_address_data.city
				this.area = select_address_data.area
				this.selectedArea = [province, city, area]

			},
			get_address_data() {
				// debugger
				var data = {
					id: window.localStorage.getItem('eshop_user_id')
				}
				var self = this
				fetchPost('/ro/web_eshop/user/address/list/v1', data).then(response => {
					// console.log(response)

					self.address_datas = response.data.list
					self.set_default_address()

				})
			},
			compute_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				// debugger
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total += parseFloat(shopcart[i].total)
				}

				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},

			handleShopcartUpdated(updatedData) {
				this.shopcart = updatedData;
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty = updatedData;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total = updatedData;
			},

			get_shop_cart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				console.log(shopcart)
				this.shopcart = shopcart
			},

			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			turn_to_new_address() {
				this.$router.push('/user/address/new')
			},
			handleSelectionChange(val) {
				this.order_line = val;

				var select_shopcart_qty = 0
				var select_shopcart_total = 0
				for (var i = 0; i < val.length; i++) {
					select_shopcart_qty += val[i].qty
					select_shopcart_total += parseFloat(val[i].total)
				}

				this.select_shopcart_qty = select_shopcart_qty
				this.select_shopcart_total = parseFloat(select_shopcart_total).toFixed(2)
			},
			beforeDestroy() {
			    this.stop_pay_state_timer();  // 确保在组件销毁时清除定时器
				// 清除倒计时定时器
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				if (this.get_pay_state_timer) {
					clearInterval(this.get_pay_state_timer);
					this.get_pay_state_timer = null; // 可选，清除引用
				}
			}
		},
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 20px 0;
		background-image: url(../static/picture/bg-index-3.png);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: cover;
	}


	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}

	.ro-text-overflow {
		overflow: hidden;
		text-overflow: ellipsis;
		/* 将对象作为弹性伸缩盒子模型显示 */
		display: -webkit-box;
		/* 限制在一个块元素显示的文本的行数 */
		/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
		-webkit-line-clamp: 2;
		/* 设置或检索伸缩盒对象的子元素的排列方式 */
		-webkit-box-orient: vertical;
	}




	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center;
	}


	.el-table_1_column_5 {
		color: orangered;
	}

	.el-table_1_column_2 {
		text-align: left !important;
	}

	.el-table_2_column_7 {
		text-align: left !important;
		padding-left: 50px !important;
	}

	.el-radio-button__inner,
	.el-radio-group {
		display: block;
	}

	.el-radio {
		display: block;
		text-align: left;
	}

	.el-radio.is-bordered {
		border: 1px solid white;

	}

	.el-radio.is-bordered+.el-radio.is-bordered {
		margin-left: 0px !important;
	}

	.el-step__main {
		text-align: center;
	}

	.ro-address-radio {
		width: 31%;
		white-space: normal;
		height: 100px !important;
		float: left;
		text-align: left;
		border: 2px solid #cdcdcd !important;
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.el-form-item__label {
		color: #333333;
		font-weight: 500;
	}

	.ro-box-content {
		border-top: 2px solid #cdcdcd;
		margin-top: 8px;
		padding-top: 8px;
		line-height: 20px;
	}

	.el-step.is-simple .el-step__icon {
		margin-top: 10px;
	}

	.el-collapse-item__header {
		background-color: #cdcdcd;
		border-radius: 3px;
		height: 35px;
		padding: 0 10px;
		font-weight: 800;
	}

	.el-collapse-item__wrap {
		background-color: #F0F0F0;
		padding: 10px;
		font-weight: 800;
		padding-bottom: 0px !important;
	}

	.el-result {
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.el-textarea .el-input__count {
		background-color: transparent;
		bottom: -27px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #ff0000;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #ff0000;
		background: #ff0000;
	}

	.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
		box-shadow: 0 0 2px 2px #ff0000;
	}
</style>